    
/////////////////////////////////////////////////////////

if($('body').hasClass('body-index')) {

    // Use sticky header on the index page.
    $(window).on('scroll', function() {
        var top = $(this).scrollTop();
        if(top >= 700) {
            $('header.desktop').addClass('sticky');
        }
        else {
            $('header.desktop').removeClass('sticky');
        }
    });
}

if($('body').hasClass('body-services') && !$('body').hasClass('template-index')) {

    $('header').addClass('sticky');
    $('.menu').addClass('sticky');
}